// store.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    dealerInfo: {}
  },
  mutations: {
    setDealerInfo(state, info) {
      state.dealerInfo = info;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store.js